/* Paola & Joy — PDP accordion.
   <details> already handles opening, keyboard and no-JS. This adds only the
   one-at-a-time behaviour, and leaves a panel alone if it was opened by the
   server (a submitted question, say) so the answer is not hidden again. */
(function () {
  'use strict';

  function init(group) {
    if (group.dataset.ready === 'true') return;
    group.dataset.ready = 'true';

    var items = Array.prototype.slice.call(group.querySelectorAll('.pj-acc__item'));
    items.forEach(function (item) {
      item.addEventListener('toggle', function () {
        if (!item.open) return;
        items.forEach(function (other) {
          if (other !== item) other.open = false;
        });
      });
    });
  }

  function boot() { document.querySelectorAll('[data-pj-acc]').forEach(init); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    e.target.querySelectorAll('[data-pj-acc]').forEach(function (el) {
      el.dataset.ready = 'false';
      init(el);
    });
  });
})();
